import React from 'react'
import Header from '../component/Header';
import Footer from '../component/Footer';
import { Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { BaseUrl } from '../helper/BaseUrl';

const makeSlug = (name = "") =>
  name
    .toLowerCase()
    .split(",")[0]
    .trim()
    .replace(/\s+/g, "-");

export default function UserLayout({ footerHide, initialData }) {
  const [branchContent, setBranchContent] = useState(() => {
    const branches = initialData?.layout || [];
    const formatted = {};

    branches.forEach((item) => {
      const slug = makeSlug(item.name);

      formatted[slug] = {
        address: item.address,
        email: item.email,
        phone: item.contact,
        branch_slug: item.branch_slug,
        isDefault: false,
        ...item,
      };
    });

    return formatted;
  });

  useEffect(() => {
    const dataFetcher = async () => {
      try {
        const response = await axios.get(`${BaseUrl}/api/branches`);
        const branches = response.data.branch || [];
        const formatted = {};

        branches.forEach((item) => {
          const slug = makeSlug(item.name);

          formatted[slug] = {
            address: item.address,
            email: item.email,
            phone: item.contact,
            branch_slug: item.branch_slug,
            isDefault: false,
            ...item,
          };
        });

        setBranchContent(formatted);

      } catch (error) {
        console.error("Data fetch error:", error);
      }
    };

    dataFetcher();
  }, []);


  return (
    <>
      <Header branchContent={branchContent} />
      <main>
        <Outlet />
      </main>
      <Footer footerHide={footerHide} branchContent={branchContent} />
    </>
  );
}